(() => {
  function smoothScrollToHash(hash) {
    if (!hash || hash.charAt(0) !== "#") return false;
    const el = document.querySelector(hash);
    if (!el) return false;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    return true;
  }

  function handleScrollClick(e) {
    const link = e.target.closest("[data-rrsp-scroll]");
    if (!link) return;

    const href = link.getAttribute("href") || "";
    if (!href.startsWith("#")) return;

    // Only prevent default if the target exists (avoids “dead” links)
    const ok = smoothScrollToHash(href);
    if (ok) e.preventDefault();
  }

  function setPanelHeight(panel, expanded) {
    if (!panel) return;
    if (expanded) {
      panel.style.height = "auto";
      const h = panel.scrollHeight;
      panel.style.height = "0px";
      // force reflow
      panel.offsetHeight; // eslint-disable-line no-unused-expressions
      panel.style.height = h + "px";
      panel.setAttribute("data-collapsed", "false");
    } else {
      const h = panel.scrollHeight;
      panel.style.height = h + "px";
      panel.offsetHeight; // eslint-disable-line no-unused-expressions
      panel.style.height = "0px";
      panel.setAttribute("data-collapsed", "true");
    }
  }

  function handleToggle(e) {
    const btn = e.target.closest('[data-rrsp-toggle="items"]');
    if (!btn) return;

    const id = btn.getAttribute("aria-controls");
    const panel = id ? document.getElementById(id) : null;
    if (!panel) return;

    const expanded = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", expanded ? "false" : "true");
    setPanelHeight(panel, !expanded);
  }

  function handleTransitionEnd(e) {
    const panel = e.target;
    if (!(panel instanceof HTMLElement)) return;
    if (!panel.classList.contains("rrsp__items-panel")) return;

    // When expanded, lock to auto after animation completes
    if (panel.getAttribute("data-collapsed") === "false") {
      panel.style.height = "auto";
    }
  }

  document.addEventListener("click", (e) => {
    handleScrollClick(e);
    handleToggle(e);
  });

  document.addEventListener("transitionend", (e) => {
    handleTransitionEnd(e);
  });

  // If panels exist and are collapsed, ensure height is 0
  document.querySelectorAll(".rrsp__items-panel").forEach((panel) => {
    if (panel.getAttribute("data-collapsed") !== "false") {
      panel.style.height = "0px";
      panel.setAttribute("data-collapsed", "true");
    } else {
      panel.style.height = "auto";
    }
  });
})();
